import { render, staticRenderFns } from "./EditDefaultView.vue?vue&type=template&id=a3f38a50"
import script from "./EditDefaultView.vue?vue&type=script&lang=js"
export * from "./EditDefaultView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports